import { useAtomValue } from 'jotai';
import { deviceAtom } from 'store/deviceStore';
import './Header.css';
import Svgs from 'assets/svgs';
import { useQuery } from 'hooks/useQuery';

interface HeaderBtnProps {
    img?: string,
    func?: () => void
}

interface HeaderProps {
    title: string,
    leftBtn?: HeaderBtnProps,
    rightBtn?: HeaderBtnProps,
    isBack?: boolean
}

export const Header = ({ title, leftBtn, rightBtn, isBack }: HeaderProps) => {
    const { navigate } = useQuery();
    const device = useAtomValue(deviceAtom);
    const inset = device.inset;

    const buttonRender = (btn: HeaderBtnProps) => {
        if(!!btn.img && btn.func) {
            return (
                <div className="header_btn_wrapper" onClick={btn.func}>
                    <img src={btn.img} alt=""/>
                </div>
            )
        } else return <div className="header_btn_wrapper"></div>
    }

    return (
        <>
            <div className="header_wrapper" style={{ paddingTop: inset?.statusBarHeight }}>
                <div className='header_container'>
                    {isBack ? buttonRender({img: Svgs.icBack24, func: () => navigate(-1)}) :
                        buttonRender(leftBtn || {})
                    }
                    <span className='header_title'>{title}</span>
                    {buttonRender(rightBtn || {})}
                </div>
            </div>
            <div className="header_padding" style={{height: 54 + inset?.statusBarHeight}}></div>
        </>
    )
}